import './bg-bars.css';

export const BackgroundBars = () => (
  <div id="bg-bar-wrapper">
    <div id="bg-bar-1" className="bg-bar" />
    <div id="bg-bar-2" className="bg-bar" />
    <div id="bg-bar-3" className="bg-bar" />
  </div>
);
